module.exports = __webpack_public_path__ + "images/frontpage_icon@2x.png?95822b75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_icon@2x.png
// module id = 649
// module chunks = 7